import React, { createContext, useContext, useState } from "react";

const StoryContext = createContext();

export const StoryProvider = ({ children }) => {
  const [stories, setStories] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const openStoryViewer = (newStories, index = 0) => {
    setStories(newStories);
    setCurrentIndex(index);
    setIsOpen(true);
    setIsPaused(false);
  };

  const closeStoryViewer = () => {
    setStories([]);
    setCurrentIndex(0);
    setIsOpen(false);
    setIsPaused(false);
  };

  return (
    <StoryContext.Provider
      value={{
        stories,
        currentIndex,
        isOpen,
        isPaused,
        setCurrentIndex,
        setIsPaused,
        openStoryViewer,
        closeStoryViewer,
      }}
    >
      {children}
    </StoryContext.Provider>
  );
};

export const useStory = () => useContext(StoryContext);
